import { render } from "./product-section.vue?vue&type=template&id=f374699c"
import script from "./product-section.vue?vue&type=script&lang=js"
export * from "./product-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__